import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Container, Typography, Grid, Link, IconButton, Divider } from '@mui/material';
import { LinkedIn, Twitter, Email } from '@mui/icons-material';
import { servicesColors as colors } from '../theme';
const industryLinks = [
    { name: 'HVAC', href: '/services' },
    { name: 'Auto Repair', href: '/services' },
    { name: 'Plumbing', href: '/services' },
    { name: 'Electrical', href: '/services' },
    { name: 'Cleaning Services', href: '/services' },
    { name: 'Landscaping', href: '/services' },
];
const resourceLinks = [
    { name: 'How It Works', href: '/services#how-it-works' },
    { name: 'Pricing', href: '/onboarding?industry=services' },
    { name: 'FAQ', href: '/services#faq' },
    { name: 'Contact', href: 'mailto:hello@stanorai.com' },
];
const companyLinks = [
    { name: 'About Us', href: '/about' },
    { name: 'Careers', href: '/careers' },
    { name: 'Privacy Policy', href: '/privacy' },
    { name: 'Terms of Service', href: '/terms' },
];
export const Footer = () => {
    return (_jsx(Box, { component: "footer", sx: {
            py: { xs: 6, md: 8 },
            backgroundColor: colors.text,
        }, children: _jsxs(Container, { maxWidth: "lg", children: [_jsxs(Grid, { container: true, spacing: 4, children: [_jsxs(Grid, { size: { xs: 12, md: 4 }, children: [_jsx(Box, { sx: { mb: 2 }, children: _jsx("img", { src: "/assets/st_logo.svg", alt: "StanorAI", style: { height: 28, filter: 'brightness(0) invert(1)' } }) }), _jsx(Typography, { sx: {
                                        color: 'rgba(255, 255, 255, 0.7)',
                                        fontSize: '0.95rem',
                                        lineHeight: 1.7,
                                        mb: 3,
                                        maxWidth: 280
                                    }, children: "AI-powered resume screening for service businesses. Hire certified techs faster than ever before." }), _jsxs(Box, { sx: { display: 'flex', gap: 1 }, children: [_jsx(IconButton, { href: "https://linkedin.com", target: "_blank", sx: {
                                                color: 'rgba(255, 255, 255, 0.6)',
                                                '&:hover': { color: colors.secondary }
                                            }, children: _jsx(LinkedIn, {}) }), _jsx(IconButton, { href: "https://twitter.com", target: "_blank", sx: {
                                                color: 'rgba(255, 255, 255, 0.6)',
                                                '&:hover': { color: colors.secondary }
                                            }, children: _jsx(Twitter, {}) }), _jsx(IconButton, { href: "mailto:hello@stanorai.com", sx: {
                                                color: 'rgba(255, 255, 255, 0.6)',
                                                '&:hover': { color: colors.secondary }
                                            }, children: _jsx(Email, {}) })] })] }), _jsxs(Grid, { size: { xs: 6, sm: 4, md: 2 }, children: [_jsx(Typography, { sx: {
                                        fontWeight: 600,
                                        color: '#ffffff',
                                        fontSize: '0.9rem',
                                        textTransform: 'uppercase',
                                        letterSpacing: 1,
                                        mb: 2
                                    }, children: "Industries" }), industryLinks.map((link, index) => (_jsx(Link, { href: link.href, underline: "none", sx: {
                                        display: 'block',
                                        color: 'rgba(255, 255, 255, 0.6)',
                                        fontSize: '0.9rem',
                                        py: 0.75,
                                        transition: 'color 0.2s ease',
                                        '&:hover': { color: colors.secondary }
                                    }, children: link.name }, index)))] }), _jsxs(Grid, { size: { xs: 6, sm: 4, md: 2 }, children: [_jsx(Typography, { sx: {
                                        fontWeight: 600,
                                        color: '#ffffff',
                                        fontSize: '0.9rem',
                                        textTransform: 'uppercase',
                                        letterSpacing: 1,
                                        mb: 2
                                    }, children: "Resources" }), resourceLinks.map((link, index) => (_jsx(Link, { href: link.href, underline: "none", sx: {
                                        display: 'block',
                                        color: 'rgba(255, 255, 255, 0.6)',
                                        fontSize: '0.9rem',
                                        py: 0.75,
                                        transition: 'color 0.2s ease',
                                        '&:hover': { color: colors.secondary }
                                    }, children: link.name }, index)))] }), _jsxs(Grid, { size: { xs: 6, sm: 4, md: 2 }, children: [_jsx(Typography, { sx: {
                                        fontWeight: 600,
                                        color: '#ffffff',
                                        fontSize: '0.9rem',
                                        textTransform: 'uppercase',
                                        letterSpacing: 1,
                                        mb: 2
                                    }, children: "Company" }), companyLinks.map((link, index) => (_jsx(Link, { href: link.href, underline: "none", sx: {
                                        display: 'block',
                                        color: 'rgba(255, 255, 255, 0.6)',
                                        fontSize: '0.9rem',
                                        py: 0.75,
                                        transition: 'color 0.2s ease',
                                        '&:hover': { color: colors.secondary }
                                    }, children: link.name }, index)))] }), _jsxs(Grid, { size: { xs: 6, sm: 4, md: 2 }, children: [_jsx(Typography, { sx: {
                                        fontWeight: 600,
                                        color: '#ffffff',
                                        fontSize: '0.9rem',
                                        textTransform: 'uppercase',
                                        letterSpacing: 1,
                                        mb: 2
                                    }, children: "Industries" }), [
                                    { name: 'Hospitality', href: '/hospitality' },
                                    { name: 'Retail', href: '/retail' },
                                    { name: 'Logistics', href: '/logistics' },
                                    { name: 'E-commerce', href: '/ecommerce' },
                                    { name: 'Delivery', href: '/delivery' },
                                ].map((link, index) => (_jsx(Link, { href: link.href, underline: "none", sx: {
                                        display: 'block',
                                        color: 'rgba(255, 255, 255, 0.6)',
                                        fontSize: '0.9rem',
                                        py: 0.75,
                                        transition: 'color 0.2s ease',
                                        '&:hover': { color: colors.secondary }
                                    }, children: link.name }, index)))] })] }), _jsx(Divider, { sx: { my: 4, borderColor: 'rgba(255, 255, 255, 0.1)' } }), _jsxs(Box, { sx: {
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: 2
                    }, children: [_jsxs(Typography, { sx: {
                                color: 'rgba(255, 255, 255, 0.5)',
                                fontSize: '0.85rem'
                            }, children: ["\u00A9 ", new Date().getFullYear(), " StanorAI. All rights reserved."] }), _jsx(Typography, { sx: {
                                color: 'rgba(255, 255, 255, 0.5)',
                                fontSize: '0.85rem'
                            }, children: "Built for service businesses that value skilled professionals." })] })] }) }));
};
